import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database"; // Importa Realtime Database
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAAplJbKd-Swd3xa9HPmXRO2Dw-h4TkcQ8",
  authDomain: "project-244649719350630259.firebaseapp.com",
  projectId: "project-244649719350630259",
  storageBucket: "project-244649719350630259.appspot.com",
  messagingSenderId: "1094028401599",
  appId: "1:1094028401599:web:579de1ba9258f539955f0a",
  measurementId: "G-R0385EXBGH",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Firestore
const storage = getStorage(app); // Storage
const auth = getAuth(app); // Authentication
const realtimeDb = getDatabase(app); // Realtime Database
const messaging = getMessaging(app);
export { auth, db, messaging, realtimeDb, storage }; // Exporta Realtime Database
